import { h } from 'preact';
import { List } from 'adapters/list/graphqlTypes';
import { FavouritesPayload } from 'helpers/pubsub';
import translate from 'helpers/utils/translate';
import Choice, { ChoiceItem } from 'DesignSystem/Choice';

type ListProps = {
    addToList: (payload: FavouritesPayload, listId: string, name: string) => Promise<void>;
    lists: List[];
    payload: FavouritesPayload;
};

const Lists = ({ addToList, lists, payload }: ListProps) => {
    return (
        <Choice>
            {lists.map(({ listId, retail: { items }, name, quantity }) => {
                const image =
                    items[items.length - 1]?.product?.images?.find(({ quality }) => quality === 'S1')?.url ?? ' ';
                return (
                    <ChoiceItem
                        onClick={() => addToList(payload, listId, name)}
                        key={listId}
                        id={listId}
                        image={{
                            src: image,
                            alt: name,
                        }}
                        title={name || translate('Default list name')}
                        caption={translate('x items', {
                            quantity: String(quantity),
                        })}
                    />
                );
            })}
        </Choice>
    );
};

export default Lists;
